import React from "react"
import { makeStyles } from "@material-ui/core/styles"

import bg from "../assets/bg-buildings.jpg"
import SiteHeader from "./SiteHeader"
import SiteHeaderSpacer from "./SiteHeaderSpacer"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundPosition: "center top",
    display: "flex",
    position: "relative",
    width: "100vw",
    minHeight: "100vh",
    flexDirection: "column",
  },
  container: {
    margin: "auto",
    marginTop: theme.spacing(5),
    width: "100%",
  },
}))

export default function PublicLayout({ children, title }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <SiteHeader fullWidth global logo title={title} />
      <SiteHeaderSpacer />
      <div className={classes.container}>{children}</div>
    </div>
  )
}
